import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import { ToastrService } from 'ngx-toastr';
import { AnalyticService } from '../../services';

interface RawAnalytic {
  date: Date;
  deviceId: string;
  deviceName: string;
  deviceLongitude: string;
  deviceLatitude: string;
  deviceVersion: string;
  contentName: string;
  operatingSystem: string;
  browserName: string;
  username: string;
  role: string;
}

@Component({
  selector: 'export-csv',
  templateUrl: './export-csv.dialog.html',
})
export class ExportCsvDialog {
  public fieldSeparator = ',';

  constructor(
    public dialogRef: MatDialogRef<ExportCsvDialog>,
    private analyticService: AnalyticService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public filters) { }

  public export() {
    this.toastr.info('May take a while', 'Preparing CSV');
    this.analyticService.getRawAnalytics(this.filters).subscribe((data: RawAnalytic[]) => {
      const now = new Date();
      const filename = `RawAnalytics_${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
      const csvData = data.map((d) => ({
        date: d.date,
        deviceId: d.deviceId,
        deviceName: d.deviceName,
        deviceLongitude: d.deviceLongitude,
        deviceLatitude: d.deviceLatitude,
        deviceVersion: d.deviceVersion,
        contentName: d.contentName,
        operatingSystem: d.operatingSystem,
        browserName: d.browserName,
        username: d.username,
        role: d.role,
      }));
      new Angular5Csv(csvData, filename, { fieldSeparator: this.fieldSeparator, headers: ['date', 'deviceId', 'deviceName', 'deviceLongitude', 'deviceLatitude', 'deviceVersion', 'contentName', 'operatingSystem', 'browserName', 'username', 'role'] });
      this.dialogRef.close();
    });
  }
  public onNoClick(): void {
    this.dialogRef.close();
  }
}
